<template>
  <a-config-provider 
    :locale="zhCN"
    :theme="{
      token: {
        colorPrimary: '#f08300',
      },
    }"
  >
    <template #renderEmpty>
      <a-empty description="暂无数据" style="color: #FFFFFF;"></a-empty>
    </template>
    <a-spin wrapperClassName="spin" :spinning="store.loading" tip="正在加载中...">
      <router-view></router-view>
    </a-spin>
  </a-config-provider>
</template>

<script setup>
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { useLoadingStore } from './store';

const store = useLoadingStore()
</script>

<style>
  html, body {
    height: 100%;
    margin: 0;
    padding: 0;
  }
  .spin {
    height: 100%;
  }
  .ant-spin-show-text {
    z-index: 1051 !important;
  }
  .ant-spin-container {
    height: 100%;
  }
</style>

